export const PRIMARY_BACKGROUND_COLOR = 'rgba(0, 0, 0, 1)';
export const ITEM_BACKGROUND_COLOR = 'white';
export const BORDER_COLOR = 'rgba(255, 0, 0, 0.3)';
export const HEADER_TITLE_COLOR = 'rgba(255, 255, 255, 0.65)';
export const HEADING_TITLE_COLOR = 'rgba(255, 255, 255, 1)';
export const DATA_COLOR = 'rgba(255, 255, 255, 1)';
export const HEADER_BACKGROUND = 'rgba(255, 255, 255, 0.25)';
export const LOGGED_OUT_COLOR = 'rgba(255, 255, 255, 0.3)';
export const LOGGED_IN_COLOR = 'rgba(0, 255, 0, 0.3)';
export const CONNECTED_COLOR = 'rgba(134, 226, 175, 1)';
export const NOT_CONNECTED_COLOR = 'rgba(205, 59, 80, 1)';